@if (open()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" (click)="onBackdropClick()">
    <div
      class="flex max-h-[90vh] w-full flex-col overflow-hidden rounded-[20px] bg-white shadow-[0px_0px_30px_0px_rgba(0,0,0,0.15)] dark:bg-field-bg-dark"
      [class]="maxWidthClass()"
      [class.shake]="shake()"
      (animationend)="shake.set(false)"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-center justify-between px-6 pt-4">
        <div class="flex items-center gap-2" [class]="titleColorClass()">
          <h2 class="text-lg font-semibold">{{ title() }}</h2>
          <ng-content select="[modal-title-suffix]"></ng-content>
        </div>
        @if (showCloseButton()) {
          <button
            type="button"
            (click)="close()"
            aria-label="Close modal"
            class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full text-sidebar-text/60 transition-colors hover:bg-accent/10 hover:text-sidebar-text dark:text-sidebar-text-dark/60 dark:hover:text-sidebar-text-dark"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        }
      </div>

      <div class="flex-1 overflow-y-auto px-6 py-5">
        <ng-content></ng-content>
      </div>

      @if (hasFooter()) {
        <div class="px-6">
          <div
            class="flex items-center justify-end gap-3 border-form-divider py-4 dark:border-form-divider-dark"
            [class.border-t]="showFooterSeparator()"
          >
            <ng-content select="[modal-footer]"></ng-content>
          </div>
        </div>
      }
    </div>
  </div>
}
